import { KeyValueEnum } from '@/main/models/common';
import { StatusCartFilterRequest } from '@/main/models/request';

export enum CartStatusTypes {
  GET_CART_STATUS = '@cartStatus/GET_CART_STATUS',
  SAVE_CART_STATUS = '@cartStatus/SAVE_CART_STATUS',
  RESET_REDUCER_CART_STATUS = '@cartStatus/RESET_REDUCER_CART_STATUS'
}

export interface CartStatusState {
  readonly cartStatus: {
    data: KeyValueEnum[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetCartStatus {
  type: typeof CartStatusTypes.GET_CART_STATUS;
  payload: { request: StatusCartFilterRequest };
}

export interface SaveCartStatus {
  type: typeof CartStatusTypes.SAVE_CART_STATUS;
  payload: {
    data: KeyValueEnum[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerCartStatus {
  type: typeof CartStatusTypes.RESET_REDUCER_CART_STATUS;
}

export type CartStatusActionTypes =
  | GetCartStatus
  | SaveCartStatus
  | ResetReducerCartStatus;
